import PropTypes from 'prop-types';
import React, {useState} from 'react';
import {withTranslation} from 'react-i18next';
import styled from 'styled-components';
import {dateFormatFR} from '../../../../utils';
import DataTable from '../../../../common/components/Datatable/Datatable';
import {FILTER_EXPRESSION_OPERATOR, FILTER_OPERATOR} from '../../../../common/constants';
import {GRAPHQL_QUERY_CHECKOUTS} from '../../../../common/queries/checkout';
import AddCheckout from '../../../checkout/components/AddCheckout';
import CheckoutRowActionAdmin from '../../../checkout/components/CheckoutRowActionAdmin';

const MargedDiv = styled.div`
  margin-left: 5px;
  margin-right: 5px;
`;

const columns = t => [
  {
    Header: '#',
    accessor: 'id',
    sortable: true,
  },
  {
    Header: t('name'),
    accessor: 'name',
    sortable: true,
  },
  {
    Header: t('serial'),
    Cell: ({cell}) => cell.value || t('notSpecified'),
    accessor: 'serial',
    sortable: true,
  },
  {
    Header: t('merchantName'),
    accessor: 'merchant.businessName',
    sortable: true,
  },
  {
    Header: t('brand'),
    accessor: 'merchant.brand.name',
    sortable: true,
  },
  {
    Header: t('creation'),
    Cell: ({cell}) => dateFormatFR({date: cell.value}),
    accessor: 'createdAt',
    sortable: true,
  },
  {
    Header: t('action'),
    Cell: ({cell}) => <CheckoutRowActionAdmin checkout={cell.value}/>,
    accessor: row => row,
  },
];

const createFilters = (search, merchantId) => {

  const expressions = [{
    operator: FILTER_EXPRESSION_OPERATOR.And,
    filters: {
      field: 'merchant.id',
      value: merchantId,
    },
  },
  {
    operator: FILTER_EXPRESSION_OPERATOR.Or,
    filters: [{
      field: 'checkout.id',
      operator: FILTER_OPERATOR.Like,
      value: `%${search}%`,
    }, {
      field: 'checkout.name',
      operator: FILTER_OPERATOR.Like,
      value: `%${search}%`,
    }, {
      field: 'serial',
      operator: FILTER_OPERATOR.Like,
      value: `%${search}%`,
    }, {
      field: 'user.firstName',
      operator: FILTER_OPERATOR.Like,
      value: `%${search}%`,
    }, {
      field: 'user.lastName',
      operator: FILTER_OPERATOR.Like,
      value: `%${search}%`,
    },
    {
      field: 'brand.name',
      operator: FILTER_OPERATOR.Like,
      value: `%${search}%`,
    },{
      field: 'merchant.businessName',
      operator: FILTER_OPERATOR.Like,
      value: `%${search}%`,
    }],
  }];


  return {
    expressions,
    relations: ['merchant', 'user', 'brand'],
  };
};

const additionalFilters = (
  <MargedDiv>
    <AddCheckout />
  </MargedDiv>
);


const MerchantCheckoutsDetails = ({t, merchantId}) => {
  const [search, setSearch] = useState('');


  return (
    <DataTable
      columns={columns(t)}
      keyResult="checkouts"
      query={GRAPHQL_QUERY_CHECKOUTS}
      defaultSort={{field: 'name'}}
      advancedFilters={createFilters(search, merchantId)}
      additionalFilters={additionalFilters}
      onSearch={value => setSearch(value)}/>
  );
};

MerchantCheckoutsDetails.propTypes = {
  t: PropTypes.func.isRequired,
  merchantId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default withTranslation('checkout')(MerchantCheckoutsDetails);
